import { cycle, price } from '../api/utils';
// import SubscriptionMixin from '../mixins/SubscriptionMixin';
import type { Dialogs } from '~/types/plugins/dialogs';
import { nextTick } from 'vue';
export default defineNuxtPlugin({
  async setup() {
    const nuxtApp = useNuxtApp();
    const { getName } = useSubscription();
    const {
      $auth,
      $i18n,
      $config,
      $globals,
      $subscription,
      $dayjs,
      $api,
      $customGtm,
    } = nuxtApp;
    const route = useRoute();
    const router = useRouter();
    const localePath = useLocalePath();
    const { t: $t } = $i18n;
    const dialogs: Dialogs = reactive({
      isSinglePurchase: false,
      shareDialog: false,
      shareGamePopup: false,
      freePlayDialog: false,
      successDialog: false,
      freePlayDialogLimit: false,
      cancelPopUpV2: false,
      confirmSubscribePopUpV2: false,
      editInfo: false,
      onBoardingPop: false,
      showAvatarList: false,
      gameTrailerDialog: false,
      subscribeDialog: false,
      subscribeDecideDialog: false,
      subscriptionPopup: false,
      subscriptionPopupV2: false,
      subscriptionPopupV3: false,
      subscriptionPopWithGroups: false,
      purchasePopup: false,
      purchasePopToggle: false,
      purchasedItemContentType: '',
      purchaseResultCredit: false,
      singlePurchaseTitle: '',
      sharedItem: {},
      subTypeCategoryInfo: {},
      confirmPurchaseDialog: false,
      confirmSinglePurchaseDialog: false,
      singlePurchaseItem: {},
      gameTrailer: {},
      voucherTitle: '',
      voucherStatus: '',
      subscriptionErrorCode: 0,
      SubscriptionFeedbackDialog: false,
      SubscriptionFeedbackDialogV2: false,
      CreditCardPaymentOptionsDialog: false,
      SubscriptionFeedbackArticleTitle: '',
      subscriptiionTypeId: 0,
      subscriptionStatus: '',
      subscriptionCategory: '',
      subscriptionCycle: '',
      subscriptionRedirectionUrl: '',
      subscriptionLangauge: '',
      subscriptionPrice: 0,
      gameTrailerURL: '',
      gameGalleryDialog: false,
      gameScreenShots: [],
      gamesCurrentUrl: '',
      gameUrl: '',
      storiesDialog: false,
      deviceNotSupported: false,
      loginNotSupportedByWifi: false,
      storyItem: {},
      storyItemsArr: [],
      confirmationDialog: false,
      confirmationDialogData: {},
      subscribeDialogCount: 0,
      subscribeDialogItem: {},
      customSubscriptionDialog: false,
      subTyebs: [] as any,
      isPartnerSubscriptionFlow: false,
      loginDialog: false,
      articleId: '',
      item: {},
      wifiNotsupportedMessage: '',
      subGroups: [],
      purchaseType: '',
      loader: false,
      popupWithText: false,
      popupSMS: false,
      redirectUrl: '',
      subTypeId: 0,
      purchaseID: '',
      openInActiveSubscription: false,
      renewable: false,
      openCreditExpiration: false,
      userCreditSubscription: {},
      subscriptionName: '',
      redeemDialog: false,
      redeemFeedbackDialog: false,
      redeemFeedbackId: 0,
      redeemFeedbackStatus: 0,
      subscriptionMentRedirect: '',
      loginSubscriptionErrorDialog: false,
      parentalControlPop: false,
      parentalControlPopRedirect: '',
      subscriptionI18nMessage: '',
      imgUrl: '',
      imgModal: false,
      resetParentalPassDialog: false,
      paymentOptionsDialog: false,
      oneTimePaymentOptionsDialog: false,
      voucherPurchasePop: false,
      feedbackDialog: false,
      paymentOptions: [],
      subType: {},
      joinTournamentDialog: false,
      tournamentItem: {},
      openSessionExpired: false,
      challengeDialog: false,
      ratingDialog: false,
      ratedItem: {},
      joinChellengePop: false,
      chellengeItem: {},
      confirmCancelPop: false,
      cancelSubData: {},
      genericErrorDialog: false,
      genericErrorDialogStatus: 0,
      subscriptionDialogV2: false,
      nonSupportedDeviceDisclaimer: false,
      migrateSubId: 0,
      resendingVoucherStatus: '',
      resendVoucherDialog: false,
      partnerSubscriptionCustomDialog: false,
      partnerSelectedOptions: [],
      genericDoubleOptInOptions: '',
      isInPartnerManageFlow: false,
      selectedPartnerSubscriptions: [],
      endSubscriptionFlowDialog: false,
      endSubscriptionFlowData: {},
      endSubscriptionFlowWithRedirect: false,
      endSubscriptionFlowWithRedirectData: '',
      selectedSubcriptionObject: [],
      loginOptions: false,
      loginOrSignUpDialog: false,
      loginOrSignUpDialogOptions: {},
      doupleOptInWithConsent: false,
      showExternalLogoutPopup: false,
      doupleOptInWithConsentData: {},
      subscriptionArticleTitle: '',
      upgradeDowngradeTxt: '',
      showGameHtmlIFrame: false,
      hideSubscriptionFeedbackCTA: false,
      partnerDialogLogo: null,
      loginOrSignUpDialogSession: '',
      appInstallerDialog: false,
      iframeGameActionsDialog: false,
      maternaDialog: false,
      customFeedbackDialog: false,
      customFeedbackDialogData: {},
      selectedUserCardMethodForPayment: '',
      paymentWebFlowUrl: '',
      onContinuePaymentWithSelectedUserCard: false,
      shortcutDialog: false,
      getSubscribedInfo: computed<any>(() => {
        return {
          typeId: dialogs.subscriptiionTypeId,
          cycle: dialogs.subscriptionCycle,
          category: dialogs.subscriptionCategory,
          status: dialogs.subscriptionStatus,
          i18nMessage: dialogs.subscriptionI18nMessage,
          redirection: dialogs.subscriptionRedirectionUrl,
          language: dialogs.subscriptionLangauge,
          price: dialogs.subscriptionPrice,
          isSinglePurchase: dialogs.isSinglePurchase,
          name: dialogs.subscriptionName,
          mentRedirect: dialogs.subscriptionMentRedirect,
          migrateSubId: dialogs.migrateSubId,
        };
      }),
      isLoggedIn: computed(() => {
        let user = $auth.user;
        return user?.roles[0] === 'user';
      }),
      expirationPopupHandler: () => {
        const userCreditSubscriptions = $subscription.userCreditSubscriptions;

        if (!userCreditSubscriptions || !userCreditSubscriptions.length) {
          // STOP
          return;
        }

        for (const userCreditSubscription of userCreditSubscriptions) {
          if (
            (!userCreditSubscription.endDate &&
              !userCreditSubscription.nextRenewalDate) ||
            userCreditSubscription?.subscriptionType?.accumulateContingent
          ) {
            continue;
          }

          const creditEndDate = userCreditSubscription.endDate
            ? userCreditSubscription.endDate
            : userCreditSubscription.nextRenewalDate;

          const creditAmount = userCreditSubscription.contingents.reduce(
            (acc: string, c: { [key: string]: string }) => {
              acc += c.amount;
              return acc;
            },
            0,
          );

          if (creditAmount === 0) {
            continue;
          }

          const expirationDaysAlert =
            +$globals.enabledExpirationPopup.expirationDaysAlert;

          const expirationHoursAlert =
            +$globals.enabledExpirationPopup.expirationHoursAlert;

          let currentDate = $dayjs();
          let endDate = $dayjs(creditEndDate);

          let diffHours = endDate.diff(currentDate, 'hours');

          if (userCreditSubscription.subscriptionType.billingCycle === 'P1D') {
            if (diffHours > expirationHoursAlert) {
              continue;
            }
          } else {
            if (diffHours / 24 > expirationDaysAlert) {
              continue;
            }
          }
          dialogs.openCreditExpiration = true;
          dialogs.userCreditSubscription = userCreditSubscription;
          break;
        }
      },
      openImgModal: (imgUrl?: string) => {
        dialogs.imgModal = true;
        if (imgUrl) {
          dialogs.imgUrl = imgUrl;
        }
      },
      closeImgModal: () => {
        dialogs.imgModal = false;
      },
      openEditInfo() {
        this.editInfo = false;
      },
      openParentalControlDialog: (redirect?: string) => {
        dialogs.parentalControlPop = true;
        if (redirect) {
          dialogs.parentalControlPopRedirect = redirect;
        }
      },
      closeParentalControlDialog: () => {
        dialogs.parentalControlPop = false;
      },
      openResetParentalPassDialog: () => {
        dialogs.resetParentalPassDialog = true;
      },
      closeResetParentalPassDialog: () => {
        dialogs.resetParentalPassDialog = false;
      },
      openRedeemDialog: () => {
        dialogs.redeemDialog = true;
      },
      closeRedeemDialog: () => {
        dialogs.redeemDialog = false;
      },
      openRedeemFeedbackDialog: (
        redeemFeedbackId: RedeemFeedback,
        status?: number | string,
      ) => {
        dialogs.redeemFeedbackId = redeemFeedbackId;
        dialogs.redeemFeedbackDialog = true;
        if (status) {
          dialogs.redeemFeedbackStatus = status;
        }
      },
      closeRedeemFeedbackDialog: () => {
        dialogs.redeemFeedbackDialog = false;
      },
      openshareDialog: (item, event = null) => {
        let triggerElement = null;
        let elementId = null;

        if (event && event.currentTarget) {
          triggerElement = event.currentTarget;
          elementId =
            triggerElement.id ||
            `share-trigger-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

          if (!triggerElement.id) {
            triggerElement.setAttribute('data-focus-id', elementId);
          }
        } else if (
          document.activeElement &&
          document.activeElement !== document.body
        ) {
          triggerElement = document.activeElement;
          elementId =
            triggerElement.id ||
            `share-trigger-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

          if (!triggerElement.id) {
            triggerElement.setAttribute('data-focus-id', elementId);
          }
        }

        dialogs.shareDialog = true;
        dialogs.sharedItem = item;

        if (elementId) {
          window?.postMessage('storeTriggerElement:' + elementId, '*');
        }
      },
      openShareGamePopup: (item, event = null) => {
        let triggerElement = null;
        let elementId = null;

        if (event && event.currentTarget) {
          triggerElement = event.currentTarget;
          elementId =
            triggerElement.id ||
            `share-trigger-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

          if (!triggerElement.id) {
            triggerElement.setAttribute('data-focus-id', elementId);
          }
        } else if (
          document.activeElement &&
          document.activeElement !== document.body
        ) {
          triggerElement = document.activeElement;
          elementId =
            triggerElement.id ||
            `share-trigger-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

          if (!triggerElement.id) {
            triggerElement.setAttribute('data-focus-id', elementId);
          }
        }

        dialogs.shareGamePopup = true;
        dialogs.sharedItem = item;

        if (elementId) {
          window?.postMessage('storeTriggerElement:' + elementId, '*');
        }
      },
      openfreePlayDialog() {
        this.freePlayDialog = true;
      },
      openOnboardingPopup() {
        this.onBoardingPop = true;
      },
      openAvatarList() {
        dialogs.showAvatarList = true;
      },
      openfreePlayDialogLimit() {
        this.freePlayDialogLimit = true;
      },
      openRatingDialog: (item: {}) => {
        dialogs.ratingDialog = true;
        dialogs.ratedItem = item;
      },
      openConfirmationDialog: (item: {}) => {
        dialogs.confirmationDialog = true;
        dialogs.confirmationDialogData = item;
      },
      openGamesTrailerDialog: (openDialog, game) => {
        dialogs.gameTrailerDialog = openDialog;
        dialogs.gameTrailer = game;
      },
      openGamesGalleryDialog: (openDialog, screenShots, currentUrl) => {
        dialogs.gameGalleryDialog = openDialog;
        dialogs.gameScreenShots = screenShots;
        dialogs.gamesCurrentUrl = currentUrl;
      },
      openStoriesDialog: (item: {}, items: []) => {
        dialogs.storiesDialog = true;
        dialogs.storyItem = item;
        dialogs.storyItemsArr = items;
      },
      openSubscribeDialog: (category, item = {}) => {
        const mappingSubscription =
          $config?.application?.base?.mappingSubscription;
        let mapValue;
        let previousUrlMap;
        const splitRoute = route.path.split('/');
        const splitPrevRoute = $subscription.previousUrl?.split('/');
        if (
          splitRoute.indexOf($i18n.locale) !== -1 ||
          splitPrevRoute.indexOf($i18n.locale) !== -1
        ) {
          const trimmedPath = route.path.slice(
            route.path.indexOf($i18n.locale) + 2,
            route.path.length,
          );
          const trimmedPrevPath = $subscription.previousUrl?.slice(
            $subscription.previousUrl?.indexOf($i18n.locale) + 2,
            $subscription.previousUrl?.length,
          );
          mapValue = mappingSubscription[trimmedPath];
          previousUrlMap = mappingSubscription[trimmedPrevPath];
        } else {
          mapValue = mappingSubscription[route.path];
          previousUrlMap = mappingSubscription[$subscription.previousUrl];
        }

        if (mapValue) {
          if (mapValue == 'idecide') {
            dialogs.subscribeDialog = false;
            dialogs.openSubscribeDecideDialog();
          } else {
            dialogs.subscribeDialog = false;
            dialogs.getSubTypesCategoryInfo(mapValue);
            dialogs.subscribeDialog = true;
          }
        } else if (previousUrlMap) {
          if (previousUrlMap == 'idecide') {
            dialogs.subscribeDialog = false;
            dialogs.openSubscribeDecideDialog();
          } else {
            dialogs.subscribeDialog = false;
            dialogs.getSubTypesCategoryInfo(previousUrlMap);
            dialogs.subscribeDialog = true;
          }
        } else {
          dialogs.subscribeDialogItem = item;
          if (dialogs.subscribeDialogCount < 2) {
            dialogs.getSubTypesCategoryInfo(category);
            dialogs.subscribeDialog = true;
          } else {
            dialogs.openSubscribeDecideDialog();
          }
          dialogs.subscribeDialogCount++;
        }
      },
      openSubscribeDecideDialog: async (
        items?,
        itemInfo?,
        redirectUrl?,
        item?: any,
        skipAllowConfirmation?: Boolean,
        isPartnerSubscriptionFlow: boolean = false,
        subTypeId?: number,
      ): Promise<OpenSubscribeDecideDialogResult> => {
        if (isPartnerSubscriptionFlow) {
          dialogs.isPartnerSubscriptionFlow = isPartnerSubscriptionFlow;
        }
        let marketingCampaign = sessionStorage.getItem('marketingCampaign');
        if ($api.tenant?.default?.subAuthRequired && !marketingCampaign) {
          if (!dialogs.isLoggedIn) {
            if (item) {
              dialogs.openLoginDialog(
                item.id,
                item?.contentType,
                redirectUrl,
                subTypeId,
              );
            } else {
              dialogs.openLoginDialog('', '', '', subTypeId);
            }
            return OpenSubscribeDecideDialogResult.LOGIN;
          }
        }
        if (
          $globals.enabledFeatures.directSubscriptionFlow &&
          skipAllowConfirmation &&
          ((Array.isArray(items[0]) &&
            items.length == 1 &&
            items[0]?.length == 1) ||
            (!Array.isArray(items[0]) && items.length == 1))
        ) {
          let typeId;
          if (Array.isArray(items[0]) && items.length == 1) {
            typeId = items[0] && items[0][0]?.id;
          } else if (!Array.isArray(items[0]) && items.length == 1) {
            typeId = items[0]?.id;
          }
          let query = Object.assign({}, route.query);
          $subscription.subscribe(
            typeId,
            $i18n.locale,
            location.href,
            query.purchaseID,
            query.purchaseType,
          );
          return OpenSubscribeDecideDialogResult.REDIRECT;
        }
        if (Array.isArray(items[0]) && items.length > 1) {
          // [[...],[...],....]
          if ($api.tenant && $api.tenant.default?.redirectToSubPage) {
            if (
              !item ||
              (item.contentType !== 'FULL_TRACK_MUSIC' &&
                item.contentType !== 'PODCAST')
            ) {
              router.push(localePath('/subscription'));
              return OpenSubscribeDecideDialogResult.REDIRECT;
            }
          }
          dialogs.subTyebs = items;
          if ($api?.tenant?.default?.V2Modals) {
            dialogs.item = item;
            dialogs.subscriptionDialogV2 = true;
          } else {
            nextTick(() => {
              dialogs.subscriptionPopWithGroups = true;
            });
          }
        } else if (
          Array.isArray(items[0]) &&
          items.length == 1 &&
          items[0]?.length > 1
        ) {
          // [[...]]
          dialogs.subTyebs = items[0] as [];
          if ($api?.tenant?.default?.V2Modals) {
            dialogs.subscriptionDialogV2 = true;
          } else {
            dialogs.subscriptionPopup = true;
          }
        } else {
          // [{...}, {...}]
          if (
            $api.tenant &&
            $api.tenant.default?.subAuthRequired &&
            items.length === 1
          ) {
            dialogs.subTyebs = items;
            if (
              $api.tenant.default?.showPaymentOptions &&
              (($api.tenant && !Array.isArray(dialogs.subTyebs[0])) ||
                (Array.isArray(dialogs.subTyebs[0]) &&
                  dialogs.subTyebs[0]?.length == 1))
            ) {
              dialogs.loader = true;
              let subType: any = !Array.isArray(dialogs.subTyebs[0])
                ? dialogs.subTyebs[0]
                : dialogs.subTyebs[0] && dialogs.subTyebs[0][0];
              const res = await $subscription.getPaymentOptions(
                subType.id,
                $i18n.locale,
                window.location.href,
              );
              const options = res?.data?.options;
              dialogs.loader = false;
              if (options) {
                dialogs.openPaymentOptionsPop(options, subType);
                return OpenSubscribeDecideDialogResult.OPENDIALOG;
              }
              return OpenSubscribeDecideDialogResult.NOACTION;
            }
            dialogs.subTyebs = Array.isArray(items[0]) ? items[0] : items;
            if ($api?.tenant?.default?.V2Modals) {
              dialogs.item = item;
              dialogs.subscriptionDialogV2 = true;
            } else {
              if ($api.tenant?.default?.SubscriptionPopUpV2) {
                dialogs.subscriptionPopupV2 = true;
              } else if ($api.tenant?.default?.monsooqMent) {
                dialogs.subscriptionPopupV3 = true;
              } else {
                dialogs.subscriptionPopup = true;
              }
            }
          } else {
            dialogs.subTyebs = Array.isArray(items[0]) ? items[0] : items;
            if ($api?.tenant?.default?.V2Modals) {
              dialogs.item = item || items[0];
              dialogs.subscriptionDialogV2 = true;
            } else {
              if ($api.tenant?.default?.SubscriptionPopUpV2) {
                dialogs.subscriptionPopupV2 = true;
              } else if ($api.tenant?.default?.monsooqMent) {
                dialogs.subscriptionPopupV3 = true;
              } else {
                dialogs.subscriptionPopup = true;
              }
            }
          }
        }

        dialogs.articleId = item?.id || dialogs.articleId || dialogs.purchaseID;
        dialogs.purchaseType = item?.contentType || dialogs.purchaseType;
        dialogs.redirectUrl = redirectUrl;
        const trackObj = {
          EL: itemInfo?.EL
            ? itemInfo?.EL
            : `${
                $subscription.getDefaultSubscription(dialogs.subTyebs)?.name
              } Subcripition Pop Up`,
          EV: $subscription.getDefaultSubscription(dialogs.subTyebs)?.name,
          EC: itemInfo?.EC ? itemInfo?.EC : 'Subscription Plans',
          EN: 'cta_click',
          AT: 'click',
          BN: 'Subscribe',
          AI: item?.id || dialogs.articleId || dialogs.purchaseID,
          AN: itemInfo?.title,
          DU: dialogs.redirectUrl,
        };
        if (itemInfo?.carouselTitle) {
          $customGtm?.track({
            ...trackObj,
            EA: `Click to ${itemInfo.carouselTitle}`,
          });
          return OpenSubscribeDecideDialogResult.NOACTION;
        }
        $customGtm?.track({
          ...trackObj,
          EA: itemInfo?.title
            ? `Click to ${itemInfo.title}`
            : 'Subscription Plans',
        });
        return OpenSubscribeDecideDialogResult.NOACTION;
      },
      openPurchasePop: (item, subGroups) => {
        dialogs.item = item;
        dialogs.purchasePopup = true;
        dialogs.subGroups = subGroups;
      },
      openPurchasedPopup: (
        contentType: string,
        showCredit?: boolean,
        singlePurchaseTitle?: string,
      ) => {
        if (dialogs.loader) {
          dialogs.loader = false;
        }
        dialogs.purchasePopToggle = true;
        dialogs.purchasedItemContentType = contentType;
        if (showCredit) {
          dialogs.purchaseResultCredit = showCredit;
        }
        if (singlePurchaseTitle) {
          dialogs.singlePurchaseTitle = singlePurchaseTitle;
        }
      },
      openLoginDialog: (
        articleId?,
        purchaseType?,
        redirectUrl?,
        subTypeId?,
      ) => {
        dialogs.loginDialog = true;
        if (articleId) dialogs.articleId = articleId;
        if (purchaseType) dialogs.purchaseType = purchaseType;
        if (redirectUrl) {
          dialogs.redirectUrl = redirectUrl;
        }
        if (subTypeId) {
          dialogs.subTypeId = subTypeId;
        }
      },
      openGenericErrorDialog: (status) => {
        dialogs.genericErrorDialog = true;
        dialogs.genericErrorDialogStatus = status;
      },
      openEndSubscriptionFlowDialog(subType) {
        dialogs.endSubscriptionFlowDialog = true;
        dialogs.endSubscriptionFlowData = subType;
      },
      closeEndSubscriptionFlowDialog() {
        dialogs.endSubscriptionFlowDialog = false;
      },
      openEndSubscriptionFlowWithRedirect(error) {
        dialogs.endSubscriptionFlowWithRedirect = true;
        dialogs.endSubscriptionFlowWithRedirectData = error;
      },
      closeGenericErrorDialog: () => {
        dialogs.genericErrorDialog = false;
      },
      filterSubTypesByCategory: (category) => {
        if (
          !$subscription.subscriptionTypes ||
          !Array.isArray($subscription.subscriptionTypes)
        ) {
          // console.info('subscriptionTypes not loaded');
          return;
        }

        return $subscription.subscriptionTypes.filter((el: any) => {
          let subTypes = JSON.parse(
            el.attributes.find((el: any) => el.key === 'ment_category').value,
          );
          return subTypes[0] === category && subTypes.length === 1;
        });
      },
      getSubTypesCategoryInfo: (category) => {
        let subTypes;
        if (category === 'all') {
          const allCategsObj: any = $subscription?.getAllCategories;
          for (const i in allCategsObj) {
            subTypes = allCategsObj[i];
          }
        } else {
          subTypes = dialogs.filterSubTypesByCategory(category);
        }

        let name = getName(subTypes[0]);
        let image = subTypes[0].attributes.find(
          (el: any) => el.key === 'ment_background_image',
        )?.value;
        let note = subTypes[0].attributes.find(
          (el: any) => el.key === 'ment_note',
        ).value;
        let contentType = note.replace('ment_note.', '');

        let defaultSubType = subTypes.filter((el: any) =>
          el.attributes.find((el: any) => el.key === 'ment_default'),
        );
        let defaultSubTypeId = defaultSubType[0].id;
        let defaultSubTypePrice = price(
          defaultSubType[0].subscriptionTypePrice,
          defaultSubType[0].attributes,
          nuxtApp,
        );

        let defaultSubTypeCycle = defaultSubType[0].billingCycle;

        dialogs.subTypeCategoryInfo = {
          name: name,
          image: image,
          note: note,
          defaultSubTypeId: defaultSubTypeId,
          defaultSubTypePrice: defaultSubTypePrice,
          defaultSubTypeCycle: defaultSubTypeCycle,
          contentType: contentType,
        };
      },
      closeDialogsOnRouteChange: () => {
        dialogs.subscribeDialog = false;
        dialogs.subscribeDecideDialog = false;
        dialogs.loginDialog = false;
        dialogs.storiesDialog = false;
        dialogs.deviceNotSupported = false;
        dialogs.oneTimePaymentOptionsDialog = false;
        dialogs.voucherPurchasePop = false;
        dialogs.feedbackDialog = false;
      },
      showUserPurchaseOptionsDialog: async (
        purchaseSubTypes: any,
      ): Promise<OpenSubscribeDecideDialogResult | void> => {
        if (purchaseSubTypes && $subscription.subsIsReady) {
          let purchaseSubTypeIds = (purchaseSubTypes as any)?.split(',');
          const subGroups: [] = $subscription.getClubs(
            purchaseSubTypeIds,
          ) as [];
          let purchaseIds = subGroups && subGroups.length ? subGroups : [];
          if ($subscription.isSubscribedToAny(purchaseIds.flat())) {
            return OpenSubscribeDecideDialogResult.NOACTION;
          }
          const openSubscribeDecideDialogResult: OpenSubscribeDecideDialogResult =
            await dialogs.openSubscribeDecideDialog(purchaseIds);
          if (
            openSubscribeDecideDialogResult ===
              OpenSubscribeDecideDialogResult.REDIRECT ||
            openSubscribeDecideDialogResult ===
              OpenSubscribeDecideDialogResult.LOGIN
          ) {
            return openSubscribeDecideDialogResult;
          }
          let query = Object.assign({}, route.query);

          delete query.articleId;
          router.replace({
            query,
          });
        }
      },
      openPaymentWebFlowInIframe(url: string) {
        dialogs.paymentWebFlowUrl = url;
        dialogs.showPaymentWebFlowIframe = true;
      },

      ///// Subscriptions Dialogs /////
      openConfirmPurchase: (
        typeId: number,
        lang: string,
        redirection: string,
        purchaseID: number,
        purchaseType: string,
        renewable: boolean,
        migrateSubId: number,
        subscriptionType?: any,
        articleTitle?: string,
      ) => {
        dialogs.setSubscriptionData(
          typeId,
          lang,
          redirection,
          subscriptionType,
          articleTitle,
        );
        if (
          $api.tenant?.default?.monsooqMent &&
          !$api.tenant?.default?.vodacomMent
        ) {
          dialogs.confirmSubscribePopUpV2 = true;
        } else {
          dialogs.confirmPurchaseDialog = true;
        }
        dialogs.articleId = dialogs.articleId || purchaseID;
        dialogs.purchaseType = dialogs.purchaseType || purchaseType;
        dialogs.renewable = renewable;
        dialogs.migrateSubId = migrateSubId;
      },
      openConfirm: (
        typeId: number,
        lang: string,
        redirection: string,
        subscriptionType?: any,
      ) => {
        dialogs.setSubscriptionData(
          typeId,
          lang,
          redirection,
          subscriptionType,
        );
        if (
          $api.tenant?.default?.monsooqMent &&
          !$api.tenant?.default?.vodacomMent
        ) {
          dialogs.confirmSubscribePopUpV2 = true;
        } else {
          dialogs.confirmPurchaseDialog = true;
        }
      },
      openSinglePurchaseConfirm: (item: any, credit?: boolean) => {
        dialogs.confirmSinglePurchaseDialog = true;
        if (credit) {
          dialogs.singlePurchaseItem = { ...item, credit };
        } else {
          dialogs.singlePurchaseItem = item;
        }
      },
      openSubscriptionFeedbackDialog: (
        statusNumber: number,
        cycle: string = '',
        category: string = '',
        isSinglePurchase: boolean = false,
        errorCode?: string | number,
        errorMessage?: string,
        articleTitle?: string,
        hideCTA?: boolean,
      ) => {
        dialogs.subscriptionCycle = cycle;
        dialogs.subscriptionCategory = category;
        dialogs.isSinglePurchase = isSinglePurchase;
        if (statusNumber === 1) {
          dialogs.subscriptionStatus = 'success';
        } else if (statusNumber === 2) {
          dialogs.subscriptionStatus = 'insufficient';
        } else if (statusNumber === 3) {
          dialogs.subscriptionStatus = 'duplicate';
        } else if (statusNumber === 5) {
          dialogs.subscriptionStatus = 'knownError';
        } else if (statusNumber === 6) {
          dialogs.subscriptionStatus = 'pending';
          dialogs.subscriptionI18nMessage = errorMessage;
          dialogs.hideSubscriptionFeedbackCTA = !!hideCTA;
        } else {
          dialogs.subscriptionStatus = 'error';
          dialogs.subscriptionErrorCode =
            errorCode && !isNaN(+errorCode) ? +errorCode * 95 : ''; // random number to hide the real error code
          dialogs.subscriptionI18nMessage = errorMessage;
        }
        if ($api.tenant?.default?.monsooqMent) {
          dialogs.SubscriptionFeedbackDialogV2 = true;
        } else {
          dialogs.SubscriptionFeedbackDialog = true;
        }
        articleTitle &&
          (dialogs.SubscriptionFeedbackArticleTitle = articleTitle);
      },
      openFeedbackDialog: (statusNumber, errorCode, voucherTitle?) => {
        dialogs.feedbackDialog = true;
        if (voucherTitle) {
          dialogs.voucherTitle = voucherTitle;
        }
        dialogs.subscriptionErrorCode = errorCode;
        if (statusNumber === 1) {
          dialogs.voucherStatus = 'success';
        } else if (statusNumber === 2) {
          dialogs.voucherStatus = 'insufficient';
        } else if (statusNumber === 3) {
          dialogs.voucherStatus = 'duplicate';
        } else if (statusNumber === 6) {
          dialogs.voucherStatus = 'pending';
        } else if (statusNumber === 7) {
          dialogs.voucherStatus = 'notFound';
        } else {
          dialogs.voucherStatus = 'error';
        }
      },
      openExternalLogoutPopup: () => {
        dialogs.showExternalLogoutPopup = true;
      },
      startSubscriptionDialog: async (
        typeId: number,
        status: number,
        errorCode?: Number | string | undefined,
        errorMessage?: string,
        subscriptionType?,
        hideCTA?: boolean,
      ) => {
        if (typeId) {
          await dialogs.setSubscriptionData(
            typeId,
            null,
            null,
            subscriptionType,
          );
          try {
            if (dialogs.subscriptionCategory) {
              const selectedCategory = JSON.parse(dialogs.subscriptionCategory);
              dialogs.openSubscriptionFeedbackDialog(
                status,
                dialogs.subscriptionCycle,
                selectedCategory,
                false,
                errorCode,
                errorMessage,
                undefined,
                hideCTA,
              );
            } else {
              // console.info('Incorrect Type ID');
            }
          } catch (error) {
            console.error(
              'error in parsing subscriptionCategory in dialogs plugin',
            );
          }
        } else {
          // console.info('No IDs');
        }
      },
      setSubscriptionData: async (
        typeId: number,
        lang?: string,
        redirect?: string,
        subscriptionObject?,
        articleTitle?: string,
      ) => {
        dialogs.selectedSubcriptionObject = subscriptionObject;
        dialogs.subscriptiionTypeId = subscriptionObject?.id || typeId;
        const subscription =
          subscriptionObject ||
          $subscription.subscriptionTypes.find((el) => {
            return el.id === +typeId;
          });
        await dialogs.prepareDataAfterSetSubscription(
          !subscription ? typeId : null,
          lang,
          redirect,
          subscription,
          articleTitle,
        );
      },
      async prepareDataAfterSetSubscription(
        typeId?,
        lang?: string,
        redirect?: string,
        subscriptionObject?,
        articleTitle?: string,
      ) {
        try {
          const subscription =
            subscriptionObject ||
            (await $api.endPoints.getEnabledSubscriptionTypeById(typeId));
          if (subscription) {
            dialogs.subscriptionCycle = $t(cycle(subscription.billingCycle));
            dialogs.subscriptionCategory = subscription.attributes.find(
              (el: any) => el.key === 'ment_category',
            ).value;
            dialogs.subscriptionMentRedirect = subscription.attributes.find(
              (el: any) => el.key === 'ment_redirect',
            )?.value;
            dialogs.subscriptionPrice = price(
              subscription.subscriptionTypePrice,
              subscription.attributes,
              nuxtApp,
            );
            dialogs.subscriptionName = getName(subscription);
            if (lang) dialogs.subscriptionLangauge = lang;
            if (redirect) dialogs.subscriptionRedirectionUrl = redirect;
          } else {
            return;
          }
        } catch (error) {
          console.error('error when prepareDataAfterSetSubscription');
        }
      },
      openInActiveSubscriptionDialog: () => {
        dialogs.openInActiveSubscription = true;
      },
      openPaymentOptionsPop: (options: any, sub: any) => {
        dialogs.paymentOptionsDialog = true;
        dialogs.paymentOptions = options;
        dialogs.subType = sub;
      },
      openOneTimePaymentOptionsDialog: (options: any) => {
        dialogs.oneTimePaymentOptionsDialog = true;
        dialogs.paymentOptions = options;
      },
      openVoucherPurchasePop: (options: any) => {
        dialogs.voucherPurchasePop = true;
        dialogs.paymentOptions = options;
      },
      openJoinTournamentDialog: (item: Object) => {
        dialogs.tournamentItem = item;
        dialogs.joinTournamentDialog = true;
      },
      openChallengeDialog: () => {
        dialogs.challengeDialog = true;
      },
      openJoinChellengePop: (item: Object) => {
        dialogs.joinChellengePop = true;
        dialogs.chellengeItem = item;
      },
      openConfirmCancelPop: (
        subscription: Object,
        upgradeDowngradeTxt: string,
      ) => {
        if (
          $api.tenant?.default?.monsooqMent &&
          !$api.tenant?.default?.vodacomMent
        ) {
          dialogs.cancelPopUpV2 = true;
        } else {
          dialogs.confirmCancelPop = true;
        }
        dialogs.cancelSubData = subscription;
        if (upgradeDowngradeTxt) {
          dialogs.upgradeDowngradeTxt = upgradeDowngradeTxt;
        }
      },
      closeCreditExpiration: () => {
        dialogs.openCreditExpiration = false;
        let redirectPath = $api.tenant?.default?.creditExpirationRoute;
        if (redirectPath) {
          router.push(localePath(redirectPath));
        }
      },
      openNonSupportedDeviceDisclaimer: () => {
        dialogs.nonSupportedDeviceDisclaimer = true;
      },
      openResendVoucherFeedback() {
        dialogs.resendVoucherDialog = true;
      },
      openPartnerSubscriptionDialog({ sub, selectedSubs, logo }) {
        dialogs.partnerSubscriptionCustomDialog = true;
        dialogs.partnerDialogLogo = logo;
        $subscription.setPartnerSubscriptions({
          selectedSubs,
          sub,
        });
      },
      showPartnerSubscriptionCustomDialog({ subTypeIds, logo }) {
        if (!dialogs.isLoggedIn) {
          dialogs.openLoginDialog('', '');
        } else {
          dialogs.partnerSubscriptionCustomDialog = true;
          $subscription.partnerSubscriptionsPlans = subTypeIds;
          dialogs.partnerDialogLogo = logo;
        }
      },
      openDoupleOptInWithConsent(item) {
        dialogs.doupleOptInWithConsent = true;
        dialogs.doupleOptInWithConsentData = item;
      },
      openLoginOptionsFlowPopup() {
        dialogs.loginOptions = true;
      },
      openLoginOptionsDialog(loginOptions: any[], sessionName) {
        if (loginOptions?.length == 1 && loginOptions?.[0]?.flow == 'WEB') {
          window.location.href = loginOptions?.[0]?.redirectionUrl;
        } else {
          dialogs.loginOrSignUpDialog = true;
          dialogs.loginOrSignUpDialogOptions = loginOptions;
          dialogs.loginOrSignUpDialogSession = sessionName;
        }
      },
      openLoginNotSupportedWifiPopup(wifiNotsupportedMessage) {
        dialogs.loginNotSupportedByWifi = true;
        if (wifiNotsupportedMessage) {
          dialogs.wifiNotsupportedMessage = wifiNotsupportedMessage;
        }
      },
      openGameHtmlIFrame(gameData: object, url: string) {
        dialogs.item = gameData;
        dialogs.gameUrl = url;
        dialogs.showGameHtmlIFrame = true;
      },
      openAppInstallerDialog() {
        dialogs.appInstallerDialog = true;
      },
      openIframeGameActionsDialog() {
        dialogs.iframeGameActionsDialog = true;
      },
      openMaternaDialog() {
        dialogs.maternaDialog = true;
      },
      closeMaternaDialog() {
        dialogs.maternaDialog = false;
      },
      openConfirmProfileDeleteDialog() {
        dialogs.confirmProfileDeleteDialog = true;
      },
      closeConfirmProfileDeleteDialog() {
        dialogs.confirmProfileDeleteDialog = false;
      },
      openCancelSubscriptionConfirmationDialog( subscription: any) {
        dialogs.cancelSubscriptionConfirmation = true;
        dialogs.confirmCancellationSubscription = subscription;
      },
      closeCancelSubscriptionConfirmationDialog() {
        dialogs.cancelSubscriptionConfirmation = false;
      },
      openShortcutDialog() {
        dialogs.shortcutDialog = true;
      },
      closeShortcutDialog() {
        dialogs.shortcutDialog = false;
      },
    });
    if (import.meta.client) {
      watch(
        () => $subscription.subscriptionApiFlowResponse,
        async (response: any) => {
          dialogs.paymentOptionsDialog = false;
          dialogs.subscriptionPopup = false;
          dialogs.subscriptionPopupV2 = false;
          dialogs.subscriptionPopupV3 = false;
          dialogs.subscriptionPopWithGroups = false;
          dialogs.subscriptionDialogV2 = false;
          dialogs.purchasePopup = false;
          dialogs.loader = false;
          dialogs.partnerSubscriptionCustomDialog = false;
          dialogs.selectedPartnerSubscriptions = [];
          $subscription.partnerSubscriptionsPlans = [];
          if (response) {
            const { status, typeId, i18Message, error, articleTitle } =
              response;
            switch (parseInt(status)) {
              case 200:
              case 201:
                await dialogs.startSubscriptionDialog(
                  typeId,
                  1,
                  undefined,
                  undefined,
                  articleTitle,
                );
                $subscription.getUserSubscription(true);
                break;
              case 205:
                break;
              case 202:
                await dialogs.startSubscriptionDialog(
                  typeId,
                  6,
                  undefined,
                  undefined,
                  articleTitle,
                );
                break;
              case 402:
                await dialogs.startSubscriptionDialog(
                  typeId,
                  2,
                  undefined,
                  undefined,
                  articleTitle,
                );
                break;
              case 409:
                if (
                  error ==
                    endSubscriptionFlowWithRedirect.NEED_CANCEL_SUBSCRIPTION_BEFORE_DOWNGRADE ||
                  error ==
                    endSubscriptionFlowWithRedirect.NEED_CANCEL_SUBSCRIPTION_BEFORE_UPGRADE
                ) {
                  dialogs.openEndSubscriptionFlowWithRedirect(error);
                } else {
                  await dialogs.startSubscriptionDialog(
                    typeId,
                    3,
                    undefined,
                    undefined,
                    articleTitle,
                  );
                }
                break;
              case 490:
                await dialogs.startSubscriptionDialog(
                  typeId,
                  4,
                  status,
                  undefined,
                  articleTitle,
                );
                break;
              case 400:
                await dialogs.startSubscriptionDialog(
                  typeId,
                  4,
                  status,
                  error,
                  articleTitle,
                );
                break;
              default:
                await dialogs.startSubscriptionDialog(
                  typeId,
                  4,
                  status,
                  i18Message,
                  articleTitle,
                );
                break;
            }
          }
        },
      );
      watch(
        () => $subscription.showLoader,
        (value) => {
          dialogs.loader = value;
        },
      );
      watch(
        () => $subscription.dialogsError,
        (value) => {
          if (value) {
            dialogs.openGenericErrorDialog(value);
          }
        },
      );
      watch(
        () => dialogs.isLoggedIn,
        (value: boolean) => {
          if (value) {
            dialogs.appInstallerDialog = true;
          }
        },
      );
    }
    return {
      provide: {
        dialogs,
      },
    };
  },
});

export enum RedeemFeedback {
  valid = 1,
  invalid = 2,
  expired = 3,
  pending = 4,
}

export enum OpenSubscribeDecideDialogResult {
  REDIRECT,
  OPENDIALOG,
  LOGIN,
  NOACTION,
}
export enum endSubscriptionFlowWithRedirect {
  NEED_UPGRADE_TO_PREMIUM_SUBSCRIPTION = 'NEED_UPGRADE_TO_PREMIUM_SUBSCRIPTION',
  NEED_CANCEL_SUBSCRIPTION_BEFORE_UPGRADE = 'NEED_CANCEL_SUBSCRIPTION_BEFORE_UPGRADE',
  NEED_CANCEL_SUBSCRIPTION_BEFORE_DOWNGRADE = 'NEED_CANCEL_SUBSCRIPTION_BEFORE_DOWNGRADE',
}
